module.exports = __webpack_public_path__ + "img/service.49bfc6c6.svg";